export default {
  ibisHotelsBudgetDE: 'ibis hotels/budget',
  ibisStylesBudgetDE: 'ibis Styles/budget',
  ibisHotelsHotelsDE: 'ibis hotels/hotels',
  ibisStylesStylesDE: 'ibis Styles/Styles',
  ibisBudgetBudgetDE: 'ibis budget/budget'
}
